// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__3_cU_","content":"RecentSearches_content__20--l"};